/*
 *   File : Notifications.js
 *   Author : https://evoqins.com
 *   Description :Home page of rayi
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, memo, useEffect, useRef, useState } from 'react';

// custom components
import { NotificationCard } from '../../Components/Card';
import { EmptyScreen, Loader, Pagination } from '../../Components/Others';
import { APIService } from '../../Service';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';

const ITEMS_PER_PAGE = 12;

const Notifications = () => {

    const navigate = useNavigate();
    const state = useLocation();

    const scrollRef = useRef(null);

    const [totalPageCount, setTotalPageCount] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [readAll, setReadAll] = useState({});

    const [notificationList, setNotificationList] = useState({});

    const [loader, setLoader] = useState(true);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        _notificationList();
    }, [currentPage]);



    // handle pagination
    const _handlePagination = (new_start_limit) => {
        const selected_page = Math.floor(new_start_limit / ITEMS_PER_PAGE) + 1;
        setCurrentPage(selected_page);

        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    };

    const _handleMarkAllRead = () => {
        if (notificationList.read_all === false) {
            _readAll();
        }
    };

    const _handleDetail = (type, id, is_read) => {

        if (is_read === false) {
            _readNotification(id);
        }

        if (type === 1) {
            navigate("/customers", {
                state: {
                    tab_index: 1,
                    type: "signed_up"
                }
            });
        } else if (type === 2) {
            navigate("/orders", {
                state: {
                    tab_index: 1,
                    type: "all"
                }
            })
        }
        else {
            navigate("/customers", {
                state: {
                    tab_index: 1,
                    type: "invested"
                }
            });
        }
    };

    // API - Notification list
    const _notificationList = () => {
        let is_post = true;
        let url = 'notification/list-received-notification';
        let request = {
            "page_num": currentPage,
            "page_size": ITEMS_PER_PAGE
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setNotificationList(response.data);
                setTotalPageCount(response.data.total_page)
            } else {
                setNotificationList({ notifications: [] });
            }
            setLoader(false);
        });
    };

    // API - Mark as all read
    const _readAll = () => {
        let is_post = false;
        let url = 'notification/read-all';
        let request = {}
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setReadAll(response.data)
                toast.dismiss();
                toast.success("Mark all as read", {
                    type: "success",
                    className: "e-toast",
                });
                navigate('/notifications', {
                    state: {
                        mark_as_read: true,
                        // notification_count:
                    }
                })
                _notificationList();
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        });
    };

    // API - Read notification
    const _readNotification = (id) => {
        let is_post = true;
        let url = 'notification/read';
        let request = {
            "notification_id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                // setReadCount(response.data.unread_notification)
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        });
    };
    //   ${notificationList?.notifications?.some(item => item.is_read === true) ? 'opacity-50 pointer-events-none ' : 'cursor-pointer'}`}

    return (

        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-24 e-font-weight-600 line-height-24px'>
                        Notifications
                    </p>
                </div>

                <div className='padding-52px-lr margin--80px-top'>

                    <div ref={scrollRef} className={`e-bg-ghost-white border-radius-16 padding-32px-all `}>
                        <div className='d-flex align-items-center justify-content-between margin-24px-bottom'>
                            <div className='e-text-smoky-black e-primary-font e-font-16  e-font-weight-600 line-height-20px'>
                                All notifications
                            </div>


                            {loader === false &&
                                <div className={`${notificationList.read_all === true ? 'opacity-50 pe-none ' : 'cursor-pointer'} e-text-blue-violet e-primary-font e-font-14 e-font-weight-600 line-height-16px  `}
                                    onClick={_handleMarkAllRead}
                                >
                                    Mark all as read
                                </div>
                            }
                        </div>

                        {loader ?
                            <Loader className="min-vh-100" />
                            :
                            <>
                                {notificationList.notifications.length !== 0 ?
                                    <>
                                        {notificationList.notifications.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <NotificationCard orderTitle={item.title}
                                                        orderDetails={item.description}
                                                        orderView={item.orderView}
                                                        orderDate={item.created}
                                                        is_read={item.is_read}
                                                        handleDetail={() => _handleDetail(item.notification_type, item.notification_id, item.is_read)} />
                                                </div>
                                            );
                                        })
                                        }
                                    </>
                                    :
                                    <EmptyScreen
                                        image={require('../../Assets/Image/NotFound/no-data.png')}
                                        title='No notification found'
                                    />
                                }
                            </>
                        }

                        {notificationList?.total_page > 1 &&
                            <div className="pt-4 mt-2" >
                                <Pagination itemsPerPage={ITEMS_PER_PAGE}
                                    totalPage={totalPageCount}
                                    currentPage={currentPage}
                                    forcePage={currentPage - 1}
                                    totalItems={notificationList.total_notifications}
                                    showFirstLastPages={true}
                                    // totalItemPerPage={notificationList.notifications.length}
                                    pageRangeDisplayed={0}
                                    marginPagesDisplayed={0}
                                    onChange={_handlePagination} />
                            </div>
                        }

                    </div>
                </div>
            </section>
        </Fragment>

    )
}

export default memo(Notifications);



